import { useEditorRuntimeStore } from '@modules/editor';
import { initialRuntimeStoreState } from '@modules/editor/src/stores/useEditorRuntimeStore';
import { resetEditorStore } from '@modules/editor/src/stores/useEditorStore';
import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v4-mini';

import { EditorRouteLayout } from '$/routes/Layouts/EditorLayout';
import { useCollectionStore } from '$/stores/useCollectionStore';
import { useCustomEditorStore } from '$/stores/useCustomEditorStore';

export const EditorRoute = createRoute({
  getParentRoute: () => EditorRouteLayout,
  path: '/editor',
  validateSearch: (search) =>
    z
      .object({
        projectId: z.optional(z.string()),
        folderId: z.optional(z.string()),
        isWebview: z.optional(z.boolean()),
        schoolClassId: z.optional(z.string()),
      })
      .parse(search),
  onEnter: () => {
    useCustomEditorStore.getState().resetStore();
    resetEditorStore();
    useEditorRuntimeStore.setState({ ...initialRuntimeStoreState });
  },
  onLeave: () => {
    useCustomEditorStore.getState().resetStore();
    resetEditorStore();
    useEditorRuntimeStore.setState({ ...initialRuntimeStoreState });
    useCollectionStore.getState().resetAppliedFilter();
  },
}).lazy(() => import('./EditorRoute.lazy').then((d) => d.LazyEditorRoute));
